import Header from '@/components/partials/Header.vue'

export const specialsRoutes = [
  // Прошедшие события скрыты 2026-10-06: кнопки брони ведут в закрываемый
  // Telegram @thecommunebar, на Cosmonaut — ещё и @no.more.snow. См. PROFILES.md.
  // {
  //   name: 'Cosmonaut',
  //   path: 'specials/cosmonaut',
  //   meta: { header: Header, sidebar_width_hidden: 'w-zero' },
  //   component: () => import(/* webpackChunkName: 'Cosmonaut' */ './pages/Cosmonaut.vue'),
  // },
  // {
  //   name: 'Dill Pickles',
  //   path: 'specials/dill-pickles',
  //   meta: { header: Header, sidebar_width_hidden: 'w-zero' },
  //   component: () => import(/* webpackChunkName: 'DillPickles' */ './pages/DillPickles.vue'),
  // },
  // {
  //   name: 'NYE 2024',
  //   path: 'specials/nye2024',
  //   component: () => import(/* webpackChunkName: 'NYE2024' */ './pages/Nye2024.vue'),
  //   meta: { header: Header, darkTheme: true, sidebar_width_hidden: 'w-zero' }
  // },
  {
    name: 'NYE 2025',
    path: 'specials/nye2025',
    component: () => import(/* webpackChunkName: 'NYE2025' */ './pages/Nye2025.vue'),
    meta: { header: Header, darkTheme: true, sidebar_width_hidden: 'w-zero' }
  },
  {
    name: 'NYE 2026',
    path: 'specials/nye2026',
    component: () => import(/* webpackChunkName: 'NYE2026' */ './pages/Nye2026.vue'),
    meta: { header: Header, darkTheme: true, sidebar_width_hidden: 'w-zero' }
  }
];
